// Generated file : do not modify
export enum PictoTypes
{
  NONE = 0,
  IMAGE,
  ICON,
  INITIAL
};

import Route from '@/extend/classes/Route';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Modules
export class ModuleItem {
  // Libellé HTML de l'item'
  public label: string;
  // Route d'un item
  public route: Route;

  constructor() {
    this.label = '';
    this.route = new Route();
  }
}

export class TreeItem {
  // index calculé dans le treeview
  public id: number;
  // Libellé du tree-node
  public name: string;
  // nom icon (mdi ou fa)
  public treeIcon: string;
  // Route de l'item
  public route: Route;
  // Liste des tree-nodes enfants
  public children: TreeItem[] | null;

  constructor() {
    this.id = 0;
    this.name = '';
    this.treeIcon = '';
    this.route = new Route();
    this.children = null;
  }
}

export class Picto {
  // label
  public label: string;
  // 
  public type: PictoTypes;

  constructor() {
    this.label = '';
    this.type = PictoTypes.NONE;
  }
}

export default class Module  {
  // Identifiant unique
  public id: number;
  // Nom du module
  public name: string;
  // Ordre des modules
  public ordre: number;
  // Ordre de la navigation mobile
  public ordreMobile: number;
  // Libellé HTML du module
  public label: string;
  // Libellé du module dans le treview
  public treeLabel: string;
  // nom icon (mdi ou fa)
  public treeIcon: string;
  // Liste des items du module
  public items: ModuleItem[];
  // Items du tree-view pour le module
  public treeItem: TreeItem;
  // Ajouter un item
  public add: ModuleItem;
  // Tableaux des actions
  public actions: ModuleItem[];
  // Route du module
  public route: Route;
  // Affiche dans le dashboard
  public inDashboard: boolean;
  // Masquer dans la navigation
  public hideInDrawer: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;

  constructor() {
    this.id = 0;
    this.name = '';
    this.ordre = 0;
    this.ordreMobile = 0;
    this.label = '';
    this.treeLabel = '';
    this.treeIcon = '';
    this.items = [];
    this.treeItem = new TreeItem();
    this.add = new ModuleItem();
    this.actions = [];
    this.route = new Route();
    this.inDashboard = false;
    this.hideInDrawer = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
  }

  public static fromJson (obj: Module): Module {
    const newModule: Module = new Module();
    newModule.id = obj.id;
    newModule.name = obj.name;
    newModule.ordre = obj.ordre;
    newModule.ordreMobile = obj.ordreMobile;
    newModule.label = obj.label;
    newModule.treeLabel = obj.treeLabel;
    newModule.treeIcon = obj.treeIcon;
    newModule.items = JSON.parse(JSON.stringify(obj.items));
    newModule.treeItem = JSON.parse(JSON.stringify(obj.treeItem));
    newModule.add = JSON.parse(JSON.stringify(obj.add));
    newModule.actions = JSON.parse(JSON.stringify(obj.actions));
    newModule.route = JSON.parse(JSON.stringify(obj.route));
    newModule.inDashboard = obj.inDashboard;
    newModule.hideInDrawer = obj.hideInDrawer;
    newModule.canUpdate = obj.canUpdate;
    newModule.canDelete = obj.canDelete;
    newModule.display = obj.display;
    return newModule;
  }

  public toJsonModule (): string {
    const json = {
      name: this.name,
      ordre: this.ordre,
      ordreMobile: this.ordreMobile,
      label: this.label,
      treeLabel: this.treeLabel,
      treeIcon: this.treeIcon,
      items: this.items,
      treeItem: this.treeItem,
      add: this.add,
      actions: this.actions,
      route: this.route,
      inDashboard: this.inDashboard,
      hideInDrawer: this.hideInDrawer,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
    }
    return JSON.stringify(json);
  }

  public fromModule (obj: Module): void {
    this.id = obj.id;
    this.name = obj.name;
    this.ordre = obj.ordre;
    this.ordreMobile = obj.ordreMobile;
    this.label = obj.label;
    this.treeLabel = obj.treeLabel;
    this.treeIcon = obj.treeIcon;
    this.items = obj.items;
    this.treeItem = obj.treeItem;
    this.add = obj.add;
    this.actions = obj.actions;
    this.route = obj.route;
    this.inDashboard = obj.inDashboard;
    this.hideInDrawer = obj.hideInDrawer;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
  }

  public compareModule (value: Module): boolean {
    return (this.toJsonModule() == value.toJsonModule());
  }

  public cloneModule (): Module {
    return Module.fromJson(this);
  }

  public static list (isMobile: boolean): Promise<Module[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/modules/list/' + isMobile, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Module[] = [];
              res.data.forEach(( a: Module ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static selectItems (isMobile: boolean): Promise<Module[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/modules/selectItems/' + isMobile, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Module[] = [];
              res.data.forEach(( a: Module ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(modules: Module[]) {
  }
}
